export const smsDirection = Object.freeze({
  Unknown: 0,
  Outbound: 1,
  Inbound: 2,
});
